module.exports = __webpack_public_path__ + "img/blue-tg.e7868271.png";